export class ConstantsValues {
  static readonly secondsInAMinute = 60;
  static readonly secondsInAnHour = ConstantsValues.secondsInAMinute * 60;
  static readonly secondsInADay = ConstantsValues.secondsInAnHour * 24;
  static readonly emptyGuid = '00000000-0000-0000-0000-000000000000';
  static readonly numericFiltersFormat = 'n4';
}
